import { createAction } from 'redux-api-middleware'
import type { RootState } from '../../reducers'
import { HUBBLE_API_TOKEN } from '../../store/middleware/APIUrl'
import ActionTypes from './actionTypes'

type VariantDeleteRequest = {
    type: typeof ActionTypes.VARIANT_DELETE_REQUEST;
    payload: never;
}

type VariantDeleteFailure = {
    type: typeof ActionTypes.VARIANT_DELETE_FAILURE;
    payload: Error;
}

type VariantDeleteSuccess = {
    type: typeof ActionTypes.VARIANT_DELETE_SUCCESS;
    payload: number;
}

function deleteVariant(id: number) {
    return createAction<RootState, number, never>({
        endpoint: `${HUBBLE_API_TOKEN}/ticket-variants/${id}`,
        method: 'DELETE',
        types: [
            ActionTypes.VARIANT_DELETE_REQUEST,
            ActionTypes.VARIANT_DELETE_SUCCESS,
            ActionTypes.VARIANT_DELETE_FAILURE,
        ],
    })
}

export type VariantDeleteAction = VariantDeleteRequest
    | VariantDeleteFailure
    | VariantDeleteSuccess

export default deleteVariant
